export default __webpack_public_path__ + "static/media/Antiwhale.2489ce71.png";